import { render } from "./RequestPageViewerPage.vue?vue&type=template&id=6835a12c&ts=true"
import script from "./RequestPageViewerPage.vue?vue&type=script&lang=ts"
export * from "./RequestPageViewerPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__